export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_q02_a.b60c12aa.png";